module.exports = __webpack_public_path__ + "img/icon-sb-checkmark-blue-color.3ca4583.svg";